import { render, staticRenderFns } from "./RelationsTable.vue?vue&type=template&id=bda0b34e&"
import script from "./RelationsTable.vue?vue&type=script&lang=js&"
export * from "./RelationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports